import { render, staticRenderFns } from "./vUpsellModal.vue?vue&type=template&id=9132f028&scoped=true"
import script from "./vUpsellModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./vUpsellModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vUpsellModal.vue?vue&type=style&index=0&id=9132f028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9132f028",
  null
  
)

export default component.exports